<template>
  <label class="label-wrapper">
    <input
      type="radio"
      :name="courseType"
      class="card-input-element"
      :disabled="courseType === 'parcelamento'"
      :value="course.id"
      @change="courseSelected"
    >

    <div class="panel panel-default card-input">
      <div class="panel-heading">{{ course.name }}</div>
      <div class="panel-body" v-if="!courseNotExists">
        <p>Instituição: {{ course.institution.name }}</p>
        <p>Campus: {{ course.campus.name }}</p>
        <p>Nível: {{ course.level }}</p>
        <p>Modalidade: {{ course.kind }}</p>
        <p>Turno: {{ course.shift }}</p>
      </div>
    </div>
  </label>
</template>
<script>
export default {
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    courseNotExists: {
      type: Boolean,
      default: false,
    },
    courseType: {
      type: String,
      default: '',
    },
  },
  methods: {
    courseSelected() {
      this.$emit('input', this.course);
    },
  },
};
</script>
<style lang="scss" scoped>
.label-wrapper {
  width: 100%;
}

.card-input-element {
  display: none;
}

.card-input {
  margin: 10px;
  padding: 0;
}

.card-input:hover {
  cursor: pointer;
}

.card-input-element:checked + .card-input {
  box-shadow: 0 0 1px 1px #2ecc71;
 }

</style>
